module.exports = __webpack_public_path__ + "img/onvif.269c982f.png";